import React from "react";

import { EmptyDash } from './EmptyDash';

export default function ExpandSizeColumn({ dependentValues }) {
	let { expandedWidth, expandedHeight, unExpandedWidth } = dependentValues
		, dashTest = Number(expandedWidth) + Number(unExpandedWidth)
		;

	if(isNaN(dashTest) || expandedHeight === 0 && expandedWidth === 0){ return <EmptyDash />; }

	return dashTest ? `${expandedWidth} x ${expandedHeight}` : <EmptyDash />;
}
